export const sources={avif:"__VITE_ASSET__BuA6NbK2__ 20w"};export const img={src:"__VITE_ASSET__BPbMViWT__",w:20,h:20};export default{sources:sources,img:img};